import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { englishIqResultV2Schema } from '../schemasV2';

export const getEnglishIqResultV2ResponseSchema: z.ZodSchema<
  IAPI<z.infer<typeof englishIqResultV2Schema>>
> = createApiResponseSchema(englishIqResultV2Schema) as z.ZodSchema<
  IAPI<z.infer<typeof englishIqResultV2Schema>>
>;

export type IGetEnglishIqResultV2Response = IAPI<z.infer<typeof englishIqResultV2Schema>>;
